const comparisonTable = (function() {
  const section = document.querySelector('[data-comparison-chart-popup]');
  const drawer = section.querySelector('[data-comparison-chart-popup--drawer]');
  const openPopupClass = 'show';
  const closeBtn = drawer.querySelector('[data-comparison-chart-popup--close]');
  const backdrop = drawer.querySelector('[data-comparison-chart-popup--backdrop]');

  const showPopup = function() {
    drawer.style.display = 'block';
    setTimeout(function() {
      drawer.classList.add(openPopupClass);
    }, 200);
  };

  const hidePopup = function() {
    drawer.classList.remove(openPopupClass);
    setTimeout(function() {
      drawer.style.display = 'none';
    }, 500);
  };

  return {
    init: function() {
      section.style.display = '';
      document.body.addEventListener("open-comparison-popup", showPopup);
      closeBtn.addEventListener('click', hidePopup);
      backdrop.addEventListener('click', hidePopup);
    }
  };
})();

document.addEventListener('DOMContentLoaded', function() {
  comparisonTable.init();
});
